module.exports = {
          srcSet: __webpack_public_path__ + "053db8f3389b5ca5dd52722e2271d464-653.png"+" 653w",
          images:[ {path: __webpack_public_path__ + "053db8f3389b5ca5dd52722e2271d464-653.png",width: 653,height: 374}],
          src: __webpack_public_path__ + "053db8f3389b5ca5dd52722e2271d464-653.png",
          toString:function(){return __webpack_public_path__ + "053db8f3389b5ca5dd52722e2271d464-653.png"},
          
          width: 653,
          height: 374
        }